export type GetProjectParams = {
  projectId: string
}

export type GetProjectCaseParams = {
  projectId: string
}

export type GetProjectStatistics = {
  projectId: string
}

export type GetProjectMetrics = {
  projectId: string
}

export type GetProjectFoundersReportParams = {
  projectId: string
}

export type GetProjectSeoReportParams = {
  projectId: string
}

export type GetProjectMarketCapacityReportParams = {
  projectId: string
}

export type GetProjectMarketResultsReportParams = {
  projectId: string
}

export type GetProjectFilesParams = {
  projectId: string
}

export type GetProjectMembersParams = {
  projectId: string
}

export type GetProjectCompetitorsParams = {
  projectId: string
}

export type GetProjectCompetitorParams = {
  projectId: string
  competitorId: string | number
}

export type CreateProjectCompetitorParams = {
  projectId: string
}

export type UpdateProjectCompetitorParams = {
  projectId: string
  competitorId: string | number
}

export type UpdateProjectParams = {
  projectId: string
}

export type UploadProjectFileParams = {
  projectId: string
}

export type CreateProjectGrowthPointBasicsParams = {
  projectId: string
}

export type GetProjectGrowthPointsParams = {
  projectId: string
}

export type GetWebsiteSpeedParams = {
  projectId: string
}

export type GetWebsiteContentParams = {
  projectId: string
}

export type GetWebsiteEnvironmentParams = {
  projectId: string
}

export type GetProjectCompetitorHypothesesParams = {
  projectId: string
}

const endpoints = {
  getProjects: `api/v2/users/user-id/projects/`,
  createProject: `api/v2/users/user-id/projects/`,
  updateProject: ({ projectId }: UpdateProjectParams): string => {
    return `api/v2/users/user-id/projects/${projectId}`
  },
  getProject: ({ projectId }: GetProjectParams): string => {
    return `api/v2/users/user-id/projects/${projectId}`
  },
  getProjectCase: ({ projectId }: GetProjectCaseParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/case`
  },
  getStatistics: ({ projectId }: GetProjectStatistics): string => {
    return `api/v2/users/user-id/projects/${projectId}/statistics`
  },
  getProjectMetrics: ({ projectId }: GetProjectMetrics): string => {
    return `api/v2/users/user-id/projects/${projectId}/metrics/`
  },
  getProjectFoundersReport: ({ projectId }: GetProjectFoundersReportParams): string => {
    return `api/v2/projects/${projectId}/reports/founders/`
  },
  getProjectSeoReport: ({ projectId }: GetProjectSeoReportParams): string => {
    return `api/v2/projects/${projectId}/reports/seo/`
  },
  getProjectMarketCapacityReport: ({ projectId }: GetProjectMarketCapacityReportParams): string => {
    return `api/v2/projects/${projectId}/reports/market/capacity/`
  },
  getProjectMarketResultsReport: ({ projectId }: GetProjectMarketResultsReportParams): string => {
    return `api/v2/projects/${projectId}/reports/market/results/`
  },
  getProjectFiles: ({ projectId }: GetProjectFilesParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/files`
  },
  getProjectMembers: ({ projectId }: GetProjectMembersParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/members`
  },
  getProjectCompetitors: ({ projectId }: GetProjectCompetitorsParams): string => {
    return `api/v2/projects/${projectId}/competitors/`
  },
  getProjectCompetitor: ({ projectId, competitorId }: GetProjectCompetitorParams): string => {
    return `api/v2/projects/${projectId}/competitors/${competitorId}/`
  },
  createProjectCompetitor: ({ projectId }: CreateProjectCompetitorParams): string => {
    return `api/v2/projects/${projectId}/competitors/`
  },
  updateProjectCompetitor: ({ projectId, competitorId }: UpdateProjectCompetitorParams): string => {
    return `api/v2/projects/${projectId}/competitors/${competitorId}/`
  },
  uploadProjectFile: ({ projectId }: UploadProjectFileParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/storage/files/`
  },
  createGrowthPointBasics: ({ projectId }: CreateProjectGrowthPointBasicsParams): string => {
    return `api/v2/projects/${projectId}/growth_points/definitions/basics/`
  },
  getProjectGrowthPoints: ({ projectId }: GetProjectGrowthPointsParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/growth_points/`
  },
  getWebsiteSpeed: ({ projectId }: GetWebsiteSpeedParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/website/speed`
  },
  getWebsiteContent: ({ projectId }: GetWebsiteContentParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/website/content/`
  },
  getWebsiteEnvironment: ({ projectId }: GetWebsiteEnvironmentParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/website/environment/`
  },
  getCompetitorHypothesesRecommendations: ({ projectId }: GetProjectCompetitorHypothesesParams): string => {
    return `api/v2/projects/${projectId}/recommendation/hypotheses/competitors/`
  },
}

export default endpoints
